<template>
  <SlideSidebarContainer>
    <div slot="title" class="d-flex align-items-center">
      <UserAvatar :user="user" class="mr-2" style="flex: 0 0 auto"/>
      <span>certificados de {{ user.name }}</span>
    </div>

    <UserPorfileCertificatesIndex
      type="mobile"
      :user="user"
      :per-page="15"
    />
  </SlideSidebarContainer>
</template>

<script>
  import SlideSidebarContainer from '@/components/layout/sidebars/SlideSidebarContainer'
  import UserPorfileCertificatesIndex from '@/components/user/profile/UserProfileCertificatesIndex'
  import UserAvatar from '@/components/user/UserAvatar'
  
  export default {
    components: {
      SlideSidebarContainer,
      UserPorfileCertificatesIndex,
      UserAvatar,
    },

    props: {
      user: { type: Object, required: true }
    }
  }
</script>